import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";

interface GetExcelParams {
    flag: string;
    yyyy: string;
    mm: string;
    startDate: string;
    endDate: string;
    s_p_dept: string;
    et_code: string;
}

export const usePostCustomerBillExcel = () => {
    const getExcel = async (params: GetExcelParams) => {
        try {
            const response = await axiosInstance.post(enum_api_uri.bill_excel, params, {
                responseType: "blob",
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "bill.xls");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("엑셀 다운로드 중 오류 발생:", error);
        }
    };

    return { getExcel };
};
